import React, { useEffect } from 'react';
import { requestLoginFailed, verifyNewAccount } from '../../redux/actions/authActions';
import Auth from 'pages/Auth';
import FullScreenLoading from '../../shared/ui/FullScreenLoading';
import { useAppSelector } from '../../hooks/hooks';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { validateAuth } from '../../redux/actions/authActions';

const LazyAuthorized = React.lazy(() => import('../Authorized'));

const Root = (): JSX.Element => {
  const dispatch = useDispatch();
  const location = useLocation();
  const authenticated = useAppSelector((state) => state.auth.authenticated);
  const isFirstLoading = useAppSelector((state) => state.auth.isFirstLoading);

  useEffect(() => {
    if (location.pathname !== '/login-actions/verify-email') dispatch(validateAuth());
    if (location.pathname === '/login-actions/verify-email') {
      const params = location.search;
      if (params.includes('key=')) {
        dispatch(verifyNewAccount(params));
      } else {
        dispatch(requestLoginFailed('empty key error'));
      }
    }
  }, [dispatch, location.pathname, location.search]);

  const mainContent = authenticated ? <LazyAuthorized /> : <Auth />;
  const initContent = isFirstLoading ? <FullScreenLoading /> : mainContent;

  return <>{initContent}</>;
};

export default Root;
